import { render, staticRenderFns } from "./MessageDailyBriefing.vue?vue&type=template&id=4956b96a&"
import script from "./MessageDailyBriefing.vue?vue&type=script&lang=js&"
export * from "./MessageDailyBriefing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports